import { FiEdit2, FiCheck } from 'react-icons/fi';
import Badge from '../../../../components/ui/Badge';

/**
 * Distribution Board card actions: Pass (Visual Check), Fail (new), Edit result (existing).
 */
export function DbCard({
  asset,
  sessionEntry,
  onQuickPass,
  onFailEdit,
  onEdit,
  isSyncing,
}) {
  const tested = sessionEntry != null;
  const sessionStatus = sessionEntry?.status ?? 'pass';
  const isSynced = sessionEntry?.synced ?? false;

  return (
    <div className="asset-card-actions">
      {tested && (
        <>
          {sessionStatus === 'fail' ? (
            <Badge variant="danger">Failed</Badge>
          ) : (
            <Badge variant="success">Passed</Badge>
          )}
          {isSynced ? (
            <span className="sync-saved" title="Saved to server">
              <FiCheck size={14} aria-hidden />
            </span>
          ) : (
            <Badge variant="warning" className="sync-pending">Saving…</Badge>
          )}
          <button
            type="button"
            className="btn btn-sm btn-icon"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(asset, sessionEntry);
            }}
            title="Edit result"
            aria-label="Edit result"
          >
            <FiEdit2 size={16} />
          </button>
        </>
      )}
      {!tested && (
        <>
          <button
            type="button"
            className="btn btn-sm btn-success"
            onClick={() => onQuickPass(asset)}
            disabled={isSyncing}
          >
            Pass
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => onFailEdit(asset)}
          >
            Fail
          </button>
        </>
      )}
    </div>
  );
}
